"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridColumnMenu = void 0;
const react_1 = __importDefault(require("react"));
const controls_1 = require("../../../../../controls");
const GridColumnMenu_styles_1 = require("./GridColumnMenu.styles");
const ToggleMenu_1 = require("../../../../../helpers/components/ToggleMenu/ToggleMenu");
const Popover_1 = require("../../../../../Popover");
exports.GridColumnMenu = react_1.default.memo(function GridColumnMenu(props) {
    const [element] = (0, controls_1.useDropdown)({
        renderControl: (props) => {
            return (react_1.default.createElement(controls_1.SelectButton, Object.assign({}, props.button, { "data-selector-id": "grid-core-column-menu-control", active: props.isActive, iconBefore: react_1.default.createElement(GridColumnMenu_styles_1.StyledGridColumnControlIcon, null), iconAfter: null, placeholder: null })));
        },
        popoverConfig: [
            {
                xAxis: Popover_1.X_AXIS.insideRight,
                yAxis: Popover_1.Y_AXIS.outsideBottom
            },
            {
                xAxis: Popover_1.X_AXIS.insideLeft,
                yAxis: Popover_1.Y_AXIS.outsideBottom
            },
            { xAxis: Popover_1.X_AXIS.insideLeft, yAxis: Popover_1.Y_AXIS.outsideTop },
            { xAxis: Popover_1.X_AXIS.insideRight, yAxis: Popover_1.Y_AXIS.outsideTop }
        ],
        renderPopover: ({ popover }) => {
            return (react_1.default.createElement(ToggleMenu_1.ToggleMenu, Object.assign({}, popover, { "data-selector-id": "grid-core-column-menu" }), props.items.map((i) => (react_1.default.createElement(ToggleMenu_1.ToggleMenuItem, { "data-selector-id": "grid-core-column-menu-item", key: i.id, title: i.title, isChecked: i.value, onChange: i.onClick })))));
        }
    });
    return react_1.default.createElement(GridColumnMenu_styles_1.StyledGridColumnMenu, null, element);
});
//# sourceMappingURL=GridColumnMenu.js.map